import React from "react";
import { useTranslation } from "react-i18next";
import { Container, OneColumn, SearchButton } from "../../../style";
import { Dialog } from "@mui/material";

const FileNotification = ({ alertDialog, setAlertDialog }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setAlertDialog(false);
  };

  return (
    <>
      <Dialog onClose={handleClose} open={alertDialog}>
        <br />
        <Container>
          <OneColumn>
            <h4>{t("alertIncompleteInformation")}</h4>
          </OneColumn>
        </Container>
        <Container>
          <OneColumn>
            <SearchButton onClick={handleClose}> {t("close")}</SearchButton>
          </OneColumn>
        </Container>
      </Dialog>
    </>
  );
};

export default FileNotification;
